export default "__VITE_ASSET__YfWgCaVm__"